import React from "react";
import "./description.scss";

export const Description = props => {
  return (
    <div className="description">
      <div className="objective">
        <h2>Objetivo:</h2>
        <p>{props.description}</p>
      </div>
      {props.responsabilities && (
        <div className="list_responsabilities">
          <h2>Responsabilidades: </h2>
          <List list={props.responsabilities} />
        </div>
      )}
    </div>
  );
};

function List(props) {
  return (
    <ul>
      {props.list.map(l => (
        <li className="sigle_item" key={l}>
          {l}
        </li>
      ))}
    </ul>
  );
}
